/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { SupplierRetailer } from './SupplierRetailer';
// @ts-ignore
import {
// @ts-ignore
    SupplierRetailerFromJSON,
// @ts-ignore
    SupplierRetailerFromJSONTyped,
// @ts-ignore
    SupplierRetailerToJSON,
} from './SupplierRetailer';

/**
 * 
 * @export
 * @interface UpdateSupplierRetailers
 */
export interface UpdateSupplierRetailers {
    /**
     * 
     * @type {Array<SupplierRetailer>}
     * @memberof UpdateSupplierRetailers
     */
    retailers: Array<SupplierRetailer>;
    /**
     * 
     * @type {string}
     * @memberof UpdateSupplierRetailers
     */
    operation: UpdateSupplierRetailersOperationEnum;
}


/**
 * @export
 */
export const UpdateSupplierRetailersOperationEnum = {
    Add: 'add',
    Remove: 'remove'
} as const;
export type UpdateSupplierRetailersOperationEnum = typeof UpdateSupplierRetailersOperationEnum[keyof typeof UpdateSupplierRetailersOperationEnum];


/**
 * Check if a given object implements the UpdateSupplierRetailers interface.
 */
// @ts-ignore
export function instanceOfUpdateSupplierRetailers(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "retailers" in value;
    isInstance = isInstance && "operation" in value;

    return isInstance;
}

// @ts-ignore
export function UpdateSupplierRetailersFromJSON(json: any): UpdateSupplierRetailers {
    return UpdateSupplierRetailersFromJSONTyped(json, false);
}

// @ts-ignore
export function UpdateSupplierRetailersFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSupplierRetailers {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'retailers': ((json['retailers'] as Array<any>).map(SupplierRetailerFromJSON)),
        'operation': json['operation'],
    };
}

// @ts-ignore
export function UpdateSupplierRetailersToJSON(value?: UpdateSupplierRetailers | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'retailers': ((value.retailers as Array<any>).map(SupplierRetailerToJSON)),
        'operation': value.operation,
    };
}

